export default __webpack_public_path__ + "static/media/halspan-logo-with-strapline.a4c9c3fd.svg";